<main>
  <article class="left">
    <h1><span>Make</span> remote work</h1>
    <p>
      Get your team in sync, no matter your location. Streamline processes,
      create team rituals, and watch productivity soar.
    </p>
    <a href="#">Learn more</a>
    <aside>
      <img src="../../../assets/client-databiz.svg" />
      <img src="../../../assets/client-audiophile.svg" />
      <img src="../../../assets/client-meet.svg" />
      <img src="../../../assets/client-maker.svg" />
    </aside>
  </article>
  <article class="right">
    <img src="../../../assets/image-hero-desktop.png" />
  </article>
</main>
